export enum ItemStatus {
  prepared = 'PREPARED',
  reserved = 'RESERVED',
  completed = 'COMPLETED',
}

export enum ItemType {
  take_out = 'TAKE OUT',
  dine_in = 'DINE-IN',
  delivery = 'DELIVERY'
}
